module.exports = __webpack_public_path__ + "img/logo-full.af868dae.png";